import DuckEntity from './DuckEntity';

const entity = new DuckEntity('bulkAddTransactionJobs', {
  apiPath: 'user_jobs/bulk_add_transaction_jobs',
  jsonRoot: 'bulk_add_transaction_job',
  jsonIndexRoot: 'bulk_add_transaction_jobs'
});

export default entity.reducer;
export { entity };
